import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import { getActiveBannerItems } from './actions';
import { ActiveBannerAction, ActiveBannerState } from './types';

export const INITIAL_STATE: ActiveBannerState = {};

const reducer: Reducer<ActiveBannerState, ActiveBannerAction> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case getType(getActiveBannerItems.success):
      return {
        feedback: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
